import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { PersonalizationVariantStatuses } from '../constants/personalization';
import { PAGE_PROPERTY_NAMES } from '../constants/propertyNames';
import States from 'ContentUtils/constants/States';
const IS_PERSONALIZED_STATUSES = [PersonalizationVariantStatuses.DEFAULT, PersonalizationVariantStatuses.VARIANT];
export const isPersonalizationDefault = crmObject => getContentPropertyValue(crmObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_VARIANT_STATUS) === PersonalizationVariantStatuses.DEFAULT;
export const isPersonalizationVariant = crmObject => getContentPropertyValue(crmObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_VARIANT_STATUS) === PersonalizationVariantStatuses.VARIANT;
export const isContentObjectPersonalized = crmObject => IS_PERSONALIZED_STATUSES.includes(getContentPropertyValue(crmObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_VARIANT_STATUS));
const getPersonalizationProperties = crmObject => {
  return {
    strategyId: getContentPropertyValue(crmObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID),
    variantStatus: getContentPropertyValue(crmObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_VARIANT_STATUS),
    publishStatus: getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE)
  };
};
export const isPublishablePersonalizedPage = ({
  targetPage,
  allPersonalizedPagesForContentType
}) => {
  if (!isContentObjectPersonalized(targetPage)) {
    return true;
  }
  const strategyId = getContentPropertyValue(targetPage, PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID);
  if (isPersonalizationDefault(targetPage)) {
    // Defaults are always publishable, regardless of variant publish status
    return true;
  } else if (isPersonalizationVariant(targetPage)) {
    return allPersonalizedPagesForContentType.results.every(page => {
      const {
        strategyId: pageStrategyId,
        variantStatus: pageVariantStatus,
        publishStatus: pagePublishStatus
      } = getPersonalizationProperties(page);
      return (
        // Don't care about LPs with different strategy IDs
        pageStrategyId !== strategyId ||
        // Don't care about LPs that are not defaults (variants )
        pageVariantStatus !== PersonalizationVariantStatuses.DEFAULT ||
        // If everything else is published, we can publish this variant
        pagePublishStatus === States.PUBLISHED
      );
    });
  }
  // Unreachable condition, but included for safety and clarity
  return true;
};

// This does NOT mean "can't be published". It means "can go from published to unpublished"
export const isUnpublishablePersonalizedPage = ({
  targetPage,
  allPersonalizedPagesForContentType
}) => {
  if (!isContentObjectPersonalized(targetPage)) {
    return true;
  }
  const strategyId = getContentPropertyValue(targetPage, PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID);
  if (isPersonalizationVariant(targetPage)) {
    // Variants are always unpublishable, regardless of default publish status
    return true;
  } else if (isPersonalizationDefault(targetPage)) {
    return allPersonalizedPagesForContentType.results.every(page => {
      const {
        strategyId: pageStrategyId,
        variantStatus: pageVariantStatus,
        publishStatus: pagePublishStatus
      } = getPersonalizationProperties(page);
      return (
        // Don't care about LPs with different strategy IDs
        pageStrategyId !== strategyId ||
        // Don't care about LPs that are not variants (defaults)
        pageVariantStatus !== PersonalizationVariantStatuses.VARIANT ||
        // If everything else is draft, we can unpublish this default
        pagePublishStatus === States.DRAFT
      );
    });
  }
  // Unreachable condition, but included for safety and clarity
  return true;
};